import api from ".";

export default function unwrapDataInterceptor() {
    api.interceptors.response.use(response => {
        return response.data;
    })
}